export default {
    path: '/operationManagement',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'operationManagement',
    layout: 'inner', // outer 一级菜单 inner 二级菜单
    component: () => import('./index')
  };
  